import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 380px;
  gap: 15px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 340px;
  gap: 7px;

  strong {
    font-weight: 700;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Label = styled.label`
  width: fit-content;
  font-size: 12px;
  font-weight: 600;
`;
